export default __webpack_public_path__ + "static/media/background.7b0fa9a9.png";